const constructorSdkPromise = import('@constructor-io/constructorio-client-javascript')

export default defineNuxtPlugin({
  name: 'constructor',
  parallel: true,
  async setup(nuxtApp) {
    const constructorIO = await constructorSdkPromise.then((mod) => mod.default)
    const config = useRuntimeConfig()

    const getApiKey = (locale: Locales) => {
      const siteId = localeConfig[locale].siteId
      let apiKey: string = ''

      switch (siteId) {
        case 'MichaelHillAU':
          apiKey = config.public.constructorApiKeyAu
          break
        case 'MichaelHillNZ':
          apiKey = config.public.constructorApiKeyNz
          break
        case 'MichaelHillCA':
          apiKey = locale === 'fr' ? config.public.constructorApiKeyCaFr : config.public.constructorApiKeyCaEn
          break
        default:
          apiKey = ''
      }

      if (!apiKey) {
        throw new Error('Missing API key: cannot initialise Constructor client integration.')
      }

      return apiKey
    }

    // Each instance registers its own window listeners and request queue, and every product tile asks
    // for one, so reuse an instance per configuration rather than constructing dozens per page.
    const clients = new Map<string, InstanceType<typeof constructorIO>>()
    // A client keeps the session id it was built with, so rebuild per page to let Constructor's session roll over.
    nuxtApp.hook('page:start', () => clients.clear())
    const createClient = ({ locale, userId, isMember }: { locale: Locales; userId?: string; isMember: boolean }) => {
      const key = `${locale}|${userId ?? ''}|${isMember}`
      let client = clients.get(key)
      if (!client) {
        client = new constructorIO({
          apiKey: getApiKey(locale),
          userId,
          segments: isMember ? ['member'] : ['guest'],
          sendTrackingEvents: true,
        })
        clients.set(key, client)
      }
      return client
    }

    return {
      provide: {
        constructor: createClient,
      },
    }
  },
})
